import deals from './deals'

export const queries = {
  deals,
}
export default queries
